import React from 'react'

export default function MCurriculums() {
  return (
    <div>
      hhh
    </div>
  )
}
